import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/site';
interface CTAButtonProps {
  label: string;
  subline?: string;
  id?: string;
  tone?: 'go' | 'navy';
}
export function CTAButton({
  label,
  subline,
  id,
  tone = 'go'
}: CTAButtonProps) {
  const base = tone === 'go' ? 'bg-go hover:bg-go-dark shadow-go text-white' : 'bg-navy-600 hover:bg-navy-700 shadow-lift text-white';
  return <div id={id} className="w-full" data-id="element-31" data-mp="2txjmweo65zas">
      <a href={CHECKOUT_URL} className={`group flex w-full items-center justify-center gap-2 rounded-2xl px-5 py-4 text-center text-[15px] font-extrabold uppercase leading-tight tracking-wide transition-[transform,background-color,box-shadow] duration-200 ease-out hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-navy-600 active:translate-y-0 sm:text-base md:text-lg md:py-5 ${base}`} data-id="element-32" data-mp="2p0jdpuw0wgfg">
        <span className="max-w-[22ch] sm:max-w-none" data-id="element-33" data-mp="38mfts8ehp69t">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-34" data-mp="19ahdmukcqt0c" />
      </a>
      {subline && <p className="mt-3 text-center text-[11px] font-semibold uppercase tracking-[0.08em] text-ink-muted sm:text-xs" data-id="element-35" data-mp="1i805ahsi45l7">
          {subline}
        </p>}
    </div>;
}